import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { useRouterNetworkStatuses } from '../api/index.js';
import { routerNetworkHydrated } from '../redux/reducers/routerNetwork.js';

export function useRouterNetworkHydration(): void {
  const dispatch = useDispatch();
  const { data: statuses } = useRouterNetworkStatuses();

  useEffect(() => {
    if (statuses) {
      dispatch(routerNetworkHydrated(statuses));
    }
  }, [statuses, dispatch]);
}
